<template>
   <v-dialog v-model="studentlistdialog" persistent max-width="70vh">
      <v-card>
         <v-row no-gutters>
            <v-toolbar dense class="primary white--text">
               <v-toolbar-title>Students</v-toolbar-title>
               <v-spacer></v-spacer>
               <v-btn :disabled="btndisabled" class="mx-2" @click.stop="cancelBtnClick"
                  >Cancel</v-btn
               >
               <v-btn :disabled="btndisabled" class="mx-2" @click.stop="okBtnClick">OK</v-btn>
            </v-toolbar>
            <v-card>
               <v-card v-show="showAlert" flat outlined class="red--text text-center">
                  Maximum participants selected
               </v-card>
               <v-card-title>
                  <v-text-field
                     v-model="student_search"
                     append-icon="mdi-magnify"
                     label="Search"
                     single-line
                     hide-details
                     class="pa-0"
                  ></v-text-field>
               </v-card-title>
               <v-data-table
                  class="px-2"
                  height="60vh"
                  dense
                  fixed-header
                  v-model="selectedstudents"
                  :headers="studentheaders"
                  :items="studentdata"
                  @click:row="rowClick"
                  item-key="school_id"
                  :search="student_search"
                  :single-select="singleSelect"
                  :show-select="showSelect"
               >
               </v-data-table>
            </v-card>
         </v-row>
      </v-card>
   </v-dialog>
</template>

<script>
   export default {
      props: {
         year: Array,
         gender: Object,
         // Participant
         data: Array,
         // Waitlist
         data2: {
            type: Array,
            default: function() {
               return [];
            },
         },
         dialogvisible: Boolean,
         maxselection: {
            type: Number,
            default: function() {
               return 0;
            },
         },
         singleselect: {
            type: Boolean,
            default: function() {
               return false;
            },
         },
         showselect: {
            type: Boolean,
            default: function() {
               return true;
            },
         },
      },
      data() {
         return {
            studentlistdialog: this.dialogvisible,
            selectedstudents: [],
            student_search: "",
            singleSelect: this.singleselect,
            studentdata: [],
            studentheaders: [
               {
                  text: "Code",
                  value: "student_code",
                  width: "10vh",
                  class: [this.$globalstore.table_headerclass],
               },
               {
                  text: "Name",
                  value: "fullname",
                  width: "24vh",
                  class: [this.$globalstore.table_headerclass],
               },
               {
                  text: "Gender",
                  value: "gendertext",
                  width: "9vh",
                  class: [this.$globalstore.table_headerclass],
               },
               {
                  text: "Year",
                  value: "ncyear",
                  width: "8vh",
                  class: [this.$globalstore.table_headerclass],
               },
            ],
            btndisabled: false,
            showAlert: false,
            showSelect: this.showselect,
         };
      },
      watch: {
         dialogvisible: function(newval, oldval) {
            if (newval) {
               this.loadStudentList();
               this.selectedstudents = [];
               this.studentlistdialog = true;
            }
         },
         selectedstudents: function(newval, oldval) {
            if (
               this.maxselection !== 0 &&
               this.selectedstudents.length + this.data.length > this.maxselection
            ) {
               this.showAlert = true;
               this.btndisabled = true;
            } else {
               this.showAlert = false;
               this.btndisabled = false;
            }
         },
      },

      methods: {
         rowClick(item, row) {
            row.select(!row.isSelected);
         },

         async loadStudentList() {
            let studentfilter = {
               year: this.year.map(Number),
               gender: this.gender.id,
            };

            let response = await this.$http({
               url: "/cca/getstudentlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: studentfilter,
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  if (this.data2.length > 0) {
                     this.studentdata = response.data.studentdata.filter((item) => {
                        return (
                           !this.data.some((x) => x.school_id == item.school_id) &&
                           !this.data2.some((y) => y.school_id == item.school_id)
                        );
                     });
                  } else {
                     this.studentdata = response.data.studentdata.filter((item) => {
                        return !this.data.some((x) => x.school_id == item.school_id);
                     });
                  }
               }
            });
         },
         cancelBtnClick() {
            this.studentlistdialog = false;
            this.$emit("cancel-selection");
         },
         okBtnClick() {
            this.studentlistdialog = false;
            this.$emit("save-selection", this.selectedstudents);
         },
      },
   };
</script>

<style>
   tr.v-data-table__selected {
      /* background: #7d92f5 !important; */
      background: #ffcdd2 !important;
   }
</style>
